import { GapY } from '../../../foundation/layout/gap-y';
import { TripleY } from '../../../foundation/layout/triple-y';
import { UserBar } from '../auth/user-bar';
import { MobileAppStyle } from './mobile-app.style';
import { Today } from './today/today';

export function MobileApp() {
  return (
    <MobileAppStyle.Container>
      <TripleY.Container style={{ height: '100%', width: '100%' }} $gap="20px">
        <TripleY.Side>
          <UserBar />
        </TripleY.Side>
        <TripleY.Rest>
          <GapY $gap="20px" />
          <Today />
        </TripleY.Rest>
      </TripleY.Container>
    </MobileAppStyle.Container>
  );
}
